/** @format */

import React, { useCallback, useMemo, useState, useEffect } from "react";
import "../../style/channel.css";
import { TabMenu } from "primereact/tabmenu";
import { Route, Routes, useNavigate, Navigate, useLocation } from "react-router-dom";
import SubscriptionPending from "./SubscriptionPending";
import SubscriptionApproved from "./SubscriptionApproved";
import SubscriptionDenied from "./SubscriptionDenied";

function Subscription(props) {
  const { isEdibleOilsRole, isCocoaRole, isAnimalFeedRole, isSuperAdminRole, isGrainsRole, isCornRole } = props;
  let navigate = useNavigate();
  let location = useLocation();

  let { pathname } = location;
  let menuItems = useMemo(
    () => [
      {
        label: "Pending",
        path: "pending",
        command: function () {
          navigate(this.path);
        },
      },
      {
        label: "Approved",
        path: "approved",
        command: function () {
          navigate(this.path);
        },
      },
      {
        label: "Denied",
        path: "denied",
        command: function () {
          navigate(this.path);
        },
      },
    ],
    [navigate]
  );
  let [selectedMenuItem, setSelectedMenuItem] = useState(menuItems[0]);
  useEffect(() => {
    setSelectedMenuItem((prevMenuItems) =>
      menuItems.findIndex((menuItem) => {
        let splitPath = pathname.split("/");
        let __pathname = splitPath[splitPath.length-1]
        return menuItem.path === __pathname;
      })
    );
  }, [pathname, menuItems]);

  const onTabChangeHandler = useCallback(
    (e) => {
      setSelectedMenuItem(e.index);
    },
    [setSelectedMenuItem]
  );

  return (
    <div style={{ marginTop: "1rem" }}>
      <TabMenu
        model={menuItems}
        activeIndex={selectedMenuItem}
        id='mi__tab__menu'
        className='mb-2'
        onTabChange={onTabChangeHandler}
      />
      <Routes>
        <Route
          path="pending"
          element={
            <SubscriptionPending
              isEdibleOilsRole={isEdibleOilsRole}
              isCocoaRole={isCocoaRole}
              isAnimalFeedRole={isAnimalFeedRole}
              isSuperAdminRole={isSuperAdminRole}
              isGrainsRole={isGrainsRole}
              isCornRole={isCornRole}
            />
          }
        ></Route>
        <Route
          path='approved'
          element={
            <SubscriptionApproved
              isEdibleOilsRole={isEdibleOilsRole}
              isCocoaRole={isCocoaRole}
              isAnimalFeedRole={isAnimalFeedRole}
              isSuperAdminRole={isSuperAdminRole}
              isGrainsRole={isGrainsRole}
              isCornRole={isCornRole}
            />
          }
        ></Route>
        <Route
          path='denied'
          element={
            <SubscriptionDenied
              isEdibleOilsRole={isEdibleOilsRole}
              isCocoaRole={isCocoaRole}
              isAnimalFeedRole={isAnimalFeedRole}
              isSuperAdminRole={isSuperAdminRole}
              isGrainsRole={isGrainsRole}
              isCornRole={isCornRole}
            />
          }
        ></Route>
        <Route path='*' element={<Navigate to='pending' replace />} />
      </Routes>
    </div>
  );
}

export default Subscription;
